import { isFormQuestionVisible } from './form-utils';

export const QuestionWithFiltering = ({filterValue, filters, children}) => {
        return isFormQuestionVisible({value: filterValue, appliedFilters: filters}) ? children : null;
}
